<template>
  <div class="detail">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item class="mainimg" v-for="(i,index) in res.imgArr" :key="index">
        <img class="mainimg" :src="i" alt />
      </van-swipe-item>
    </van-swipe>
    <!-- <img class="mainimg" :src="res.imgs|imgsFilter" alt /> -->
    <div class="content">
      <div class="title">
        <span>{{res.shopName}}</span>
        <a :href="`tel:${res.mobile}`">
          <img :src="require('@/assets/images/icon/detail-phone.png')" alt />
        </a>
      </div>
      <p class="position" @click="opLocation()">
        <img :src="require('@/assets/images/icon/detail-position.png')" alt />
        <span>{{res.provice}}{{res.city}}{{res.district}}{{res.detailAddress}}</span>
      </p>
      <p class="text-bold">
        <span>门店营业时间 {{res.yysj}}</span>
      </p>
      <p class="msg">{{res.shopIntroduce}}</p>
    </div>
    <div class="space"></div>
    <div class="actlist">
      <!-- 优惠活动 -->
      <template v-if="res.type1.length>0">
        <!-- @click="go(`/Activity?type=1&shopId=${res.id}`)" -->
        <div class="title">
          <div class="line"></div>
          <div class="main">优惠活动</div>
          <div v-if="isWechat" class="more" @click="go(`/Activity?type=1&shopId=${res.id}`)">查看更多</div>
        </div>
        <div
          class="card"
          v-for="(v, i) in res.type1"
          :key="i"
          @click="go(`/Activity/Normal?id=${v.id}&headShopId=${res.id}`)"
        >
          <img :src="v.img" alt />
          <div class="msg">
            <h4 class="tit">{{v.title}}</h4>
            <p>&nbsp;</p>
            <div class="price">
              <span>活动进行中</span>
              <span>¥ {{v.price|priceFilter}}</span>
            </div>
          </div>
          <img class="taglt" :src="require('@/assets/images/icon/detail-taglt.png')" alt />
        </div>
      </template>
      <!-- 拼团活动 -->
      <template v-if="res.type3.length>0">
        <div class="title">
          <div class="line"></div>
          <div class="main">拼团活动</div>
          <div v-if="isWechat" class="more" @click="go(`/Activity?type=3&shopId=${res.id}`)">查看更多</div>
        </div>

        <div
          class="card"
          v-for="(v, i) in res.type3"
          :key="i"
          @click="go(`/Activity/Tuan?id=${v.id}&headShopId=${res.id}`)"
        >
          <img :src="v.img" alt />
          <div class="msg">
            <h4 class="tit">{{v.title}}</h4>
            <p>&nbsp;</p>
            <div class="price">
              <span>活动进行中</span>
              <span>¥ {{v.price|priceFilter}}</span>
            </div>
          </div>
          <img class="taglt" :src="require('@/assets/images/icon/detail-taglt.png')" alt />
        </div>
      </template>
      <!-- 秒杀活动 -->
      <template v-if="res.type4.length>0">
        <div class="title">
          <div class="line"></div>
          <div class="main">秒杀活动</div>
          <div v-if="isWechat" class="more" @click="go(`/Activity?type=4&shopId=${res.id}`)">查看更多</div>
        </div>
        <div
          class="card"
          v-for="(v, i) in res.type4"
          :key="i"
          @click="go(`/Activity/Normal?id=${v.id}&headShopId=${res.id}`)"
        >
          <img :src="v.img" alt />
          <div class="msg">
            <h4 class="tit">{{v.title}}</h4>
            <p>&nbsp;</p>
            <div class="price">
              <span>活动进行中</span>
              <span>¥ {{v.price|priceFilter}}</span>
            </div>
          </div>
          <img class="taglt" :src="require('@/assets/images/icon/detail-taglt.png')" alt />
        </div>
      </template>
    </div>
    <div class="space"></div>
    <div class="commentlist">
      <div class="title">
        <div class="line"></div>
        <div class="main">门店详情</div>
        <div class="more"></div>
      </div>
      <img v-for="(s,index) in res.detailImgsArr" :src="s" :key="index" alt />
      <div class="title">
        <div class="line"></div>
        <div class="main">门店评价</div>
        <div
          v-if="evashow"
          class="more"
          @click="go(`/Store/assessList?id=${res.id}`)"
        >更多评价（{{commentTotal}}条）</div>
      </div>
      <div class="comments">
        <div
          class="comment"
          @click="go(`/Store/assessDetail?id=${t.id}&id1=${res.id}`)"
          v-for="(t) in comments"
          :key="t.id"
        >
          <div class="head">
            <img :src="t.headimgurl" alt />
          </div>
          <div class="mbox">
            <div class="mtop">
              <div class="mtime">
                <span>{{t.nickname}}</span>
                <em>{{t.evaluateTime}}</em>
              </div>
              <div class="star">
                <van-rate v-model="t.evaluateScore" size="10" readonly />
              </div>
            </div>
            <div class="mcontent">
              <p>{{t.evaluateContent}}</p>
              <div class="mimgs" v-if="t.evaluateImgsArr.length>0">
                <img :src="it" alt v-for="(it, index) in t.evaluateImgsArr" :key="index" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="hasevashow">暂无评价</div>
        <!-- <div class="comment">
          <div class="head">
            <img :src="require('@/assets/images/temp/avatar.png')" alt />
          </div>
          <div class="mbox">
            <div class="mtop">
              <div class="mtime">
                <span>chjshdjs</span>
                <em>2019-09-21</em>
              </div>
              <div class="star">
                <van-rate v-model="value" size="10" readonly />
              </div>
            </div>
            <div class="mcontent">
              <p>
                店面环境很整洁，工作人员很热情，干活专业，态度也非常认
                真，实在是太棒了！
              </p>
              <div class="mimgs">
                <img :src="require('@/assets/images/temp/avatar.png')" alt />
                <img :src="require('@/assets/images/temp/avatar.png')" alt />
                <img :src="require('@/assets/images/temp/avatar.png')" alt />
              </div>
            </div>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "GetCard",
  data () {
    return {
      value: 4,
      res: {
        imgs: "",
        type1: [],
        type3: [],
        type4: []
      },
      query: {},
      comments: [],
      commentTotal: 0,
      evashow: false,
      hasevashow: true
    };
  },
  computed: {},
  mounted () {
    this.query = this.getQuery(this);
    if (this.query.id) {
      this.getDetail();
      this.getCommentList();
    }
  },
  methods: {
    opLocation () {
      if (window.wx) {
        // {{res.provice}}{{res.city}}{{res.district}}{{res.detailAddress}}
        let address = this.res.provice + this.res.city + this.res.district + this.res.detailAddress;
        window.wx.openLocation({
          latitude: this.res.lbsLatitude, // 纬度，浮点数，范围为90 ~ -90
          longitude: this.res.lbsLongitude, // 经度，浮点数，范围为180 ~ -180。
          name: this.res.shopName, // 位置名
          address: address // 详细地址
        });
      }
    },
    async getDetail () {
      //  user/userReward/statistics

      let res = await this.request("/shop/shop/getDetail", {
        shopId: this.query.id
      });
      if (res.code === 0) {
        // console.log(res);
        this.res = {
          ...res.data,
          detailImgsArr: res.data.detailImgs.split(","),
          imgArr: res.data.imgs.split(',')
          // newTime:
          //   this.dateFormat(
          //     this.toTimeStamp(res.data.startTime),
          //     "yyyy年MM月dd日"
          //   ) +
          //   "-" +
          //   this.dateFormat(this.toTimeStamp(res.data.endTime), "MM月dd日"),
        };
      }
    },
    async getCommentList () {
      try {
        let res = await this.request("/shop/shop/evaluateList", {
          shopId: this.query.id,
          page: 1,
          limit: 5
        });
        // if (res.code === 0) {
        this.commentTotal = res.TotalCount;
        this.comments = res.List.map(it => {
          return {
            ...it,
            evaluateImgsArr: it.evaluateImgs ? it.evaluateImgs.split(",") : []
          };
        });

        this.comments = this.comments.filter(it => it.evaluateContent);
        this.comments.length > 3 ? this.evashow = true : this.evashow = false;
        this.comments.length === 0 ? this.hasevashow = true : this.hasevashow = false;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.$error(e.message);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";

.detail {
  .mainimg {
    width: 100%;
    height: 5.63rem;
  }
  .content {
    padding: 0.27rem 0.51rem 0.53rem 0.53rem;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.43rem;
      font-weight: bold;
      img {
        width: 0.56rem;
        height: 0.56rem;
      }
    }
    .position {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-top: 0.16rem;
      img {
        display: block;
        margin-right: 0.19rem;
        width: 0.32rem;
        height: 0.43rem;
      }
      span {
        color: #979797;
      }
    }
    .text-bold {
      margin-top: 10px;
      font-size: 14px;
    }
    .msg {
      margin-top: 0.3rem;
      font-size: 0.37rem;
      line-height: 0.53rem;
      letter-spacing: 0;
    }
  }
  .actlist {
    padding: 0 0.53rem 0.53rem;
    .title {
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
      margin-top: 0.53rem;
      .line {
        width: 0.11rem;
        height: 0.37rem;
        margin-bottom: 0.05rem;
        background: @primaryColor;
      }
      .main {
        flex: 1;
        margin-left: 0.11rem;
        font-size: 0.4rem;
        font-weight: bold;
      }
      .more {
        font-size: 0.32rem;
        color: #979797;
      }
    }
    .card {
      box-shadow: 0rem 0rem 0.27rem 0rem rgba(210, 210, 210, 0.5);
      padding: 0.27rem 0.53rem;
      margin-top: 0.37rem;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      img {
        width: 2.13rem;
        height: 2.13rem;
        margin-right: 0.53rem;
      }
      .msg {
        flex: 1;
        .tit {
          font-size: 0.37rem;
        }
        p {
          margin-top: 0.13rem;
          color: #979797;
        }
        .price {
          color: #ff8c3e;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 0.53rem;
        }
      }
      .taglt {
        position: absolute;
        width: 0.67rem;
        height: 0.64rem;
        top: 0;
        left: 0;
        // background: #ff8c3e;
      }
    }
  }
  .commentlist {
    padding: 0 0.53rem 0.53rem;
    .title {
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
      margin-top: 0.53rem;
      .line {
        width: 0.11rem;
        height: 0.37rem;
        margin-bottom: 0.05rem;
        background: @primaryColor;
      }
      .main {
        flex: 1;
        margin-left: 0.11rem;
        font-size: 0.4rem;
        font-weight: bold;
      }
      .more {
        font-size: 0.32rem;
        color: #979797;
      }
    }
    & > img {
      width: 100%;
      height: 5.01rem;
      margin-top: 0.32rem;
    }
    .comments {
      padding-top: 0.08rem;
      .comment {
        padding-top: 0.24rem;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        .head {
          width: 0.83rem;
          height: 0.83rem;
          border-radius: 0.83rem;
          margin-right: 0.27rem;
          flex-shrink: 0;
          img {
            width: 100%;
            height: 100%;
            border-radius: inherit;
          }
        }
        .mbox {
          flex: 1;
          padding-bottom: 0.27rem;
          border-bottom: 0.03rem solid #f5f5f5;
          .mtop {
            line-height: 0.45rem;
            .mtime {
              display: flex;
              span {
                flex: 1;
                font-size: 0.32rem;
              }
              em {
                font-style: normal;
                color: #979797;
              }
            }
            .star {
              @{deep} .van-rate__item {
                &:not(:last-child) {
                  padding-right: 0.05rem;
                }
                .van-rate__icon {
                  color: #ffbc49;
                }
              }
            }
          }
          .mcontent {
            margin-top: 0.27rem;
            p {
              color: #585858;
            }
            .mimgs {
              padding-top: 0.13rem;
              display: flex;
              img {
                width: 2.3rem;
                height: 2.3rem;
                &:not(:last-child) {
                  margin-right: 0.4rem;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>